@if (isErrorDisplayed()) {
  @for (error of getErrors(); track $index) {
    <div class="td-wb-input-errors__message td-wb-error"
         [class.td-wb-input-errors--note]="hasInputNote()"
         [class.td-wb-input-errors__message--right]="align() === 'right'"
         [class.td-wb-input-errors__message--single-line]="singleLineError()"
         [class.td-wb-input-errors__message--multi-line]="!singleLineError()">
      <!--<td-wb-icon data-td-wb-size="11" data-icon-id="td-wb-icon&#45;&#45;exclamation&#45;&#45;small"></td-wb-icon>-->
      <span class="td-wb-input-errors__label"
            [innerText]="error.messageKey | tdWbTranslate : errorKeyNamespaceParams()">
    </span>
    </div>
  }
}
